/* eslint-disable */
import get from 'lodash/get';
import { USER_SERVICE_PRESENCE_STATUS_UNKNOWN } from '../../../../Constants/User/User.constants';
import authCurrentSelector from './AuthCurrent.selector';

/**
 * Select the presence of the current `AuthEntity`
 * @param {any} state The state management `state`
 * @returns {null | string} The current `auth`'s presence
 */
const authPresenceSelector = (state) => {
  const auth = authCurrentSelector(state);
  return get(auth, `user.presence`, USER_SERVICE_PRESENCE_STATUS_UNKNOWN);
};

export default authPresenceSelector;
